import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Table } from '../../components/ui/Table';
import { Badge } from '../../components/ui/Badge';
import { Modal } from '../../components/ui/Modal';
import { Upload, Users, CheckCircle, AlertCircle } from 'lucide-react';
import { recipientBatches } from '../../data/mockData';
export function RecipientBatch() {
  const [showUploadModal, setShowUploadModal] = useState(false);
  const totalRecipients = recipientBatches.reduce((sum, b) => sum + b.count, 0);
  const verifiedBatches = recipientBatches.filter(b => b.status === 'Verified').length;
  return <div className="space-y-6" data-id="element-282">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-283">
        <div data-id="element-284">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-285">
            Data Penerima Bantuan (PBP)
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-286">
            Kelola data KPM (Keluarga Penerima Manfaat)
          </p>
        </div>
        <Button icon={<Upload size={18} data-id="element-288" />} onClick={() => setShowUploadModal(true)} data-id="element-287">
          Upload Data Penerima
        </Button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6" data-id="element-289">
        <Card className="border-l-4 border-l-bulog-blue" data-id="element-290">
          <div className="flex items-center gap-4" data-id="element-291">
            <div className="p-3 bg-blue-100 text-bulog-blue rounded-lg flex-shrink-0" data-id="element-292">
              <Users size={24} data-id="element-293" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-294">
              <p className="text-sm text-gray-500 mb-1" data-id="element-295">Total PBP</p>
              <p className="text-3xl font-bold text-gray-900" data-id="element-296">
                {(totalRecipients / 1000000).toFixed(1)}M
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-297">
                Keluarga Penerima Manfaat
              </p>
            </div>
          </div>
        </Card>
        <Card className="border-l-4 border-l-green-500" data-id="element-298">
          <div className="flex items-center gap-4" data-id="element-299">
            <div className="p-3 bg-green-100 text-green-600 rounded-lg flex-shrink-0" data-id="element-300">
              <CheckCircle size={24} data-id="element-301" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-302">
              <p className="text-sm text-gray-500 mb-1" data-id="element-303">Batch Terverifikasi</p>
              <p className="text-3xl font-bold text-gray-900" data-id="element-304">
                {verifiedBatches}
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-305">
                Dari {recipientBatches.length} batch
              </p>
            </div>
          </div>
        </Card>
      </div>

      <Card title="Batch Data Penerima" data-id="element-306">
        <Table columns={[{
        header: 'Batch ID',
        accessor: (item: any) => <span className="font-mono text-sm font-semibold text-bulog-blue" data-id="element-308">
                  {item.id}
                </span>
      }, {
        header: 'Wilayah',
        accessor: (item: any) => <div className="min-w-0" data-id="element-309">
                  <div className="font-semibold text-gray-900 truncate" data-id="element-310">
                    {item.region}
                  </div>
                  <div className="text-xs text-gray-500 mt-0.5" data-id="element-311">
                    {item.date}
                  </div>
                </div>
      }, {
        header: 'Jumlah KPM',
        accessor: (item: any) => <span className="font-semibold text-gray-900" data-id="element-312">
                  {item.count.toLocaleString()}
                </span>
      }, {
        header: 'Sumber Data',
        accessor: 'source',
        className: 'hidden md:table-cell'
      }, {
        header: 'Status',
        accessor: (item: any) => {
          const variants: any = {
            Verified: 'success',
            'In Review': 'warning'
          };
          return <Badge variant={variants[item.status]} data-id="element-313">{item.status}</Badge>;
        }
      }]} data={recipientBatches} keyExtractor={i => i.id} data-id="element-307" />
      </Card>

      <Modal isOpen={showUploadModal} onClose={() => setShowUploadModal(false)} title="Upload Data Penerima Bantuan" size="lg" footer={<>
            <Button variant="outline" onClick={() => setShowUploadModal(false)} data-id="element-315">
              Batal
            </Button>
            <Button onClick={() => {
        setShowUploadModal(false);
        alert('Data penerima berhasil diupload dan sedang diproses!');
      }} data-id="element-316">
              Upload & Proses
            </Button>
          </>} data-id="element-314">
        <div className="space-y-6" data-id="element-317">
          <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg" data-id="element-318">
            <div className="flex items-start gap-3" data-id="element-319">
              <AlertCircle className="text-bulog-blue mt-0.5 flex-shrink-0" size={20} data-id="element-320" />
              <div data-id="element-321">
                <p className="font-semibold text-bulog-blue mb-1" data-id="element-322">
                  Format Data P3KE
                </p>
                <p className="text-sm text-gray-700" data-id="element-323">
                  File harus dalam format CSV dengan kolom: NIK, Nama, Alamat,
                  Kecamatan, Kabupaten, Provinsi
                </p>
              </div>
            </div>
          </div>

          <div className="p-8 border-2 border-dashed border-gray-300 rounded-lg text-center" data-id="element-324">
            <Upload className="mx-auto text-gray-400 mb-3" size={48} data-id="element-325" />
            <p className="text-sm font-medium text-gray-900 mb-1" data-id="element-326">
              Upload File CSV
            </p>
            <p className="text-xs text-gray-500 mb-4" data-id="element-327">Maksimal 50MB</p>
            <Button size="sm" variant="outline" data-id="element-328">
              Pilih File
            </Button>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-329">
            <div data-id="element-330">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-331">
                Provinsi
              </label>
              <select className="w-full rounded-md border-gray-300 border py-2 px-3 text-sm" data-id="element-332">
                <option data-id="element-333">DKI Jakarta</option>
                <option data-id="element-334">Jawa Barat</option>
                <option data-id="element-335">Jawa Tengah</option>
              </select>
            </div>
            <div data-id="element-336">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-337">
                Periode
              </label>
              <input type="month" className="w-full rounded-md border-gray-300 border py-2 px-3 text-sm" data-id="element-338" />
            </div>
          </div>
        </div>
      </Modal>
    </div>;
}